import { IconLockShield24 as LockShield } from '@fabric-ds/icons/react';
import { DetailsType, SafePaymentInfoType } from 'types/uiTypes';
import pulseClient from 'resources/pulse';
import ExpandableDataContainer from './ExpandableDataContainer';
import DottetList from './DottetList';

type Props = {
    safePaymentInfo: SafePaymentInfoType;
};

type ContentProps = {
    details: DetailsType[];
};

const Content = ({ details }: ContentProps) => (
    <div className="my-24 md:my-0">
        <DottetList details={details} />
    </div>
);

const SafePaymentInfo = ({ safePaymentInfo }: Props) => {
    const { title, details } = safePaymentInfo;

    return (
        <ExpandableDataContainer
            containerClass="border-b md:border-b-0"
            icon={
                <LockShield
                    role="img"
                    aria-label="Skjold med hengelås på"
                    color="var(--f-gray-500)"
                />
            }
            title={title}
            tracker={pulseClient.trackExpandPayment}
        >
            <Content details={details} />
        </ExpandableDataContainer>
    );
};

export default SafePaymentInfo;
